import React from "react";
import { ProfileDetailItem } from "subframe/components/ProfileDetailItem";
import { Tooltip } from "@mui/material";
import * as SubframeCore from "@subframe/core";
import { ContactData } from "../../../types";
import { formatPhoneNumber } from "utils/phoneNumber";

interface ContactInformationProps {
  contact: ContactData;
}

export const ContactInformation: React.FC<ContactInformationProps> = ({ contact }) => {
  const handlePhone = () => {
    window.open(`tel:${contact.phone}`);
  };

  const handleEmail = () => {
    window.open(`mailto:${contact.email}`, "_blank");
  };

  const handleCopyPhone = async () => {
    try {
      await navigator.clipboard.writeText(contact.phone);
      alert("Phone number copied to clipboard!");
    } catch {
      alert("Failed to copy phone number");
    }
  };

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(contact.email);
      alert("Email copied to clipboard!");
    } catch {
      alert("Failed to copy email");
    }
  };

  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background px-4 py-4 shadow-sm">
      <div className="flex w-full items-center justify-between pl-0 md:pl-3">
        <span className="text-subheader font-subheader text-default-font">
          Contact information
        </span>
      </div>
      <div className="flex w-full flex-col items-start gap-4">
        <div className="flex w-full flex-col lg:flex-row items-start gap-4">
          <div className="flex flex-col items-start gap-4 w-full lg:w-auto">
            <ProfileDetailItem
              className="h-auto w-full lg:w-60 flex-none"
              variant="label"
              icon="FeatherUserCircle"
              label="First name"
              value={contact.firstName}
            />
            <ProfileDetailItem
              className="h-auto w-full lg:w-60 flex-none"
              variant="label"
              icon="FeatherUserCircle"
              label="Last name"
              value={contact.lastName}
            />
          </div>
          <div className="flex flex-col items-start gap-4 w-full lg:w-auto">
            <div className="flex flex-col items-start gap-1 w-full lg:w-60">
              <span className="text-label font-label text-neutral-500">Phone</span>
              <div className="flex items-center gap-2 w-full">
                <SubframeCore.Icon
                  className="text-body font-body text-neutral-500"
                  name="FeatherPhone"
                />
                <Tooltip title="Call">
                  <span 
                    className="text-body font-body text-default-font underline cursor-pointer flex-1"
                    onClick={handlePhone}
                  >
                    {formatPhoneNumber(contact.phone) || contact.phone}
                  </span>
                </Tooltip>
                <Tooltip title="Copy phone number">
                  <span className="cursor-pointer" onClick={handleCopyPhone}>
                    <SubframeCore.Icon
                      className="text-body font-body text-neutral-500"
                      name="FeatherCopy"
                    />
                  </span>
                </Tooltip>
              </div>
            </div>
            <div className="flex flex-col items-start gap-1 w-full lg:w-60">
              <span className="text-label font-label text-neutral-500">Email</span>
              <div className="flex items-center gap-2 w-full">
                <SubframeCore.Icon
                  className="text-body font-body text-neutral-500"
                  name="FeatherMail"
                />
                <Tooltip title="Send Email">
                  <span 
                    className="text-body font-body text-default-font underline cursor-pointer break-all flex-1"
                    onClick={handleEmail}
                  >
                    {contact.email}
                  </span>
                </Tooltip>
                <Tooltip title="Copy email">
                  <span className="cursor-pointer" onClick={handleCopyEmail}>
                    <SubframeCore.Icon
                      className="text-body font-body text-neutral-500"
                      name="FeatherCopy"
                    />
                  </span>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 